module.exports = __webpack_public_path__ + "img/0Q3A2889_L_Foamcore.81bd0f5d.jpg";